module.exports = __webpack_public_path__ + "static/media/plus-color.479a5b16.svg";